import ReactModal from 'react-modal'
import styled from 'styled-components'

export const ModalWrapper = styled(ReactModal)`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	min-width: 600px;
	min-height: 700px;
	background-color: ${({ theme }) => theme.colors.white};
	border-radius: 15px;
	box-shadow: 8px -5px 25px -10px rgba(0, 0, 0, 0.3);
	display: flex;
	justify-content: space-between;
	align-items: center;
	flex-direction: column;

	&:focus {
		outline: none;
	}
`
